import { render, staticRenderFns } from "./SearchParameters.vue?vue&type=template&id=9800155e"
import script from "./SearchParameters.vue?vue&type=script&lang=ts"
export * from "./SearchParameters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports